<template>
  <div>
    <v-menu bottom v-if="priviledged">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-account-supervisor</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="item in items"
          v-bind:key="item.id"
          @click="onSelectItem(item.id)"
        >
          <v-list-item-title>
            <v-icon>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import router from '@/router/index.js'

export default {
  name: 'administrator',

  components: {},

  data: () => ({
    items: [
      {
        id: 1,
        title: 'Association',
        icon: 'mdi-golf'
      },
      {
        id: 2,
        title: 'Manage Money List',
        icon: 'mdi-currency-usd'
      },
      {
        id: 3,
        title: 'Members',
        icon: 'mdi-account-multiple'
      },
      {
        id: 4,
        title: 'User',
        icon: 'mdi-account'
      },
      {
        id: 5,
        title: 'User Roles',
        icon: 'mdi-account-cog'
      },
      {
        id: 6,
        title: 'Payments',
        icon: 'mdi-currency-usd'
      }
    ]
  }),

  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

  methods: {
    onSelectItem(id) {
      switch (id) {
        case 1:
          router.push('/association/edit')
          break
        case 2:
          router.push('/money/manage/0')
          break
        case 3:
          router.push('/admin/members')
          break
        case 4:
          router.push('/admin/users')
          break
        case 5:
          router.push('/admin/roles')
          break
        case 6:
          router.push('/admin/payments')
      }
    }
  }
}
</script>
